import { marked } from 'marked';

class NoStrikethroughTokenizer extends marked.Tokenizer {
  del(): undefined {
    return undefined;
  }
}

/**
 * Marked options for rendering provider-authored content.
 * GFM strikethrough (~ / ~~) is disabled so ranges like "30~60" stay literal.
 */
export function getMarkedDisplayOptions(
  overrides?: marked.MarkedOptions,
): marked.MarkedOptions {
  return {
    gfm: true,
    breaks: true,
    ...overrides,
    tokenizer: new NoStrikethroughTokenizer(),
  };
}
